  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
//import Checkbox                                            from '@material-ui/core/Checkbox';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //----------
  // Libraries
  //----------
//import Cookies                                             from 'js-cookie';
  //recaptcha_V2
  import ReCAPTCHA                                           from "react-google-invisible-recaptcha";
  //recaptcha_V3
//import useRecaptchaV3                                      from "components/useRecaptchaV3/useRecaptchaV3.jsx";
  import { GoogleReCaptchaProvider, GoogleReCaptcha }        from 'react-google-recaptcha-v3';
//import TagManager                                          from 'react-gtm-module'
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
//import { wu_LoginLogoutService }                           from "../../_services";
//import { wu_ProfileService }                               from "../../_services";
  import { wu_RegisterLightService }                         from "../../_services";
  import { wu_AppVersion }                                   from "../../_services";
  //------
  // Style
  //------
  import RegisterLight1OTPStyle                              from "./RegisterLight1OTPStyle.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  //----------
  // variables
  //----------
  const filename = "RegisterLight1OTP ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }


class RegisterLight1OTP extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      viewPleaseWait_hidden                                : true,

      textField1                                           : "", //TextField
      textField1_hasError                                  : false,

      parserObject_getCountries                            : [],
      parserObject_getCountries4Picker                     : [],
      parserObject_getProfessions                          : [],
      parserObject_getProfessions4Picker                   : [],
      parserObject_getPositionLevel                        : [],
      parserObject_getPositionLevel4Picker                 : [],
      parserObject_getIdTypes                              : [],
      parserObject_getIdTypes4Picker                       : [],

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      //[HONEYMOON]
      textField0                                           : "", //4279034659
      textField0_hasError                                  : false,

      //[RECAPTCHA]
      recaptchaVersionSupported                            : "V3", //"V2", "V3", "NONE"
      //recaptcha_V3
      refreshReCaptchaV3                                   : false,
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                           = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                          = this.dialog_handleClose.bind(this);
    this.startSpinners                                               = this.startSpinners.bind(this);
    this.stopSpinners                                                = this.stopSpinners.bind(this);

    this.btn_next_act                                                = this.btn_next_act.bind(this);
    this.btn_next_act_isDisabled                                     = this.btn_next_act_isDisabled.bind(this);
    //recaptcha_V2
    this.btn_next_act_with_recaptcha                                 = this.btn_next_act_with_recaptcha.bind(this);
    this.recaptchaRef_send                                           = React.createRef();
    //recaptcha_V3
    this.btn_next_act_get_recaptchaV3_token                          = this.btn_next_act_get_recaptchaV3_token.bind(this);
  //this.reset_recaptchaV3_token                                     = this.reset_recaptchaV3_token.bind(this);

    this.btn_resend_act                                              = this.btn_resend_act.bind(this);
    this.btn_resend_act_isDisabled                                   = this.btn_resend_act_isDisabled.bind(this);
    //recaptcha_V2
    this.btn_resend_act_with_recaptcha                               = this.btn_resend_act_with_recaptcha.bind(this);
    this.recaptchaRef_resend                                         = React.createRef();
    //recaptcha_V3
    this.btn_resend_act_get_recaptchaV3_token                        = this.btn_resend_act_get_recaptchaV3_token.bind(this);
    this.reset_recaptchaV3_token                                     = this.reset_recaptchaV3_token.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                               = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                              = this.Snackbar_textField_handleClose.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);

    //--------------------
    //global variables set
    //--------------------
    try { localStorage.setItem("newRegistrationFlow","newCustomer"); } catch(err){;}
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}

    //-----------
    //recaptchaV3
    //-----------
    var recaptchaTokenV3 = localStorage.getItem("recaptchaTokenV3");
    //console.log(methName+"recaptchaTokenV3="+recaptchaTokenV3);
    if(recaptchaTokenV3===null || recaptchaTokenV3===""){
      setTimeout(function() { this.reset_recaptchaV3_token("init"); }.bind(this), 500);
    }
    this.reset_recaptchaV3_token_TIMER();
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    var RegisterLight1OTP_info_text = "";
    if(localStorage.getItem("prev_view").trim()==="LoginPage" || localStorage.getItem("prev_view").trim()==="TransferOnlineLogin"){
      let parserObject_omtRegistrationResendOTP_req = {};
      try{ parserObject_omtRegistrationResendOTP_req = JSON.parse(localStorage.getItem("parserObject_omtRegistrationResendOTP_req"));}catch(err){console.log(methName+'err='+err);}
      RegisterLight1OTP_info_text = this.NSInforString("RegisterLight1OTP_info_SMS") + parserObject_omtRegistrationResendOTP_req["telephone"];
    }
    else{
      let parserObject_omtregistrationTriggerOTP_req = {};
      try{ parserObject_omtregistrationTriggerOTP_req = JSON.parse(localStorage.getItem("parserObject_omtregistrationTriggerOTP_req"));}catch(err){console.log(methName+'err='+err);}
      RegisterLight1OTP_info_text = this.NSInforString("RegisterLight1OTP_info_SMS") + parserObject_omtregistrationTriggerOTP_req["telephone"];
    }

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>

            <div style={{ marginTop: 25 }}>
              <div className={classes.labelHeader}>{this.NSInforString("RegisterLight1OTP_title")}</div>
              <div className={classes.logo}><img src={logo} alt="logo" /></div>
            </div>

            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.label1}>{this.NSInforString("RegisterLight1OTP_lbl1")}</div>
              </GridItem>
            </GridContainer>

            <div style={{ marginTop: 25 }}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div className={classes.label1}>{RegisterLight1OTP_info_text}</div>
                </GridItem>
              </GridContainer>
            </div>

            <GridContainer justify="center">

              {/* ------------------------- */}
              {/* ----------[HONEYMOON]---- */}
              {/* ------------------------- */}
              <GridItem xs={12} sm={12} md={12} className={classes.GridItemTextField0}>
                  <TextField
                    fullWidth
                    autoComplete={this.autoCompleteText_Textfields()}
                    error={this.state.textField0_hasError}
                    className={classes.textField0}
                    id={this.autoCompleteText_Textfields()}
                    label={this.autoCompleteText_Textfields()}
                    value={this.state.textField0}
                    InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField0"), type: "text" }}
                  />
              </GridItem>

              <GridItem xs={12} sm={12} md={12}>
                <TextField
                  fullWidth
                  error={this.state.textField1_hasError}
                  className={classes.textField1}
                  id="textField1"
                  value={this.state.textField1}
                  label={this.NSInforString("RegisterLight1OTP_plh1")}
                  defaultValue=""
                  InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField1"), type: "text"  }}
                />
              </GridItem>
            </GridContainer>
            {/* ------------------------- */}
            {/* ----------[BUTTONS]------ */}
            {/* ------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={10} sm={10} md={10}>
                <div className={classes.labelHeaderX}>&nbsp;</div>
                {/* -----------recaptcha_V2 -------------- */}
                {this.state.recaptchaVersionSupported === "V2" ? (
                  <div className={classes.textCenter}>
                    <ReCAPTCHA
                      ref={ ref => this.recaptchaRef_send = ref }
                      locale={localStorage.getItem("lang")}
                      sitekey={api.captchKey}
                      onResolved={ this.btn_next_act } />
                    <CustomButton
                      disabled={this.btn_next_act_isDisabled()}
                      className={classes.yellowButton}
                      color="default"
                      onClick={this.btn_next_act_with_recaptcha}
                      type="submit">
                      {this.NSInforString("RegisterLight1OTP_btn_next")}
                    </CustomButton>
                  </div>
                ) : ( "" )}
                {/* -----------recaptcha_V3 -------------- */}
                {this.state.recaptchaVersionSupported === "V3" ? (
                  <div className={classes.textCenter}>
                    <GoogleReCaptchaProvider reCaptchaKey={api.captchKeyV3}>
                      <GoogleReCaptcha
                          className="google-recaptcha-custom-class"
                          onVerify={this.btn_next_act_get_recaptchaV3_token}
                          refreshReCaptcha={this.state.refreshReCaptchaV3}
                      />
                    </GoogleReCaptchaProvider>
                    <CustomButton
                      disabled={this.btn_next_act_isDisabled()}
                      className={classes.yellowButton}
                      color="default"
                      onClick={this.btn_next_act}
                      type="submit">
                      {this.NSInforString("RegisterLight1OTP_btn_next")}
                    </CustomButton>
                  </div>
                ) : ( "" )}
              </GridItem>
              <GridItem xs={10} sm={10} md={10}>
                {/* -----------recaptcha_V2 -------------- */}
                <div className={classes.labelHeaderX}>&nbsp;</div>
                {this.state.recaptchaVersionSupported === "V2" ? (
                  <div className={classes.textCenter}>
                    <ReCAPTCHA
                      ref={ ref => this.recaptchaRef_resend = ref }
                      locale={localStorage.getItem("lang")}
                      sitekey={api.captchKey}
                      onResolved={ this.btn_resend_act } />
                    <CustomButton
                      disabled={this.btn_resend_act_isDisabled()}
                      className={classes.transparentButton1}
                      color="default"
                      onClick={this.btn_resend_act_with_recaptcha}
                      type="submit">
                      {this.NSInforString("RegisterLight1OTP_btn_resend")}
                    </CustomButton>
                  </div>
                ) : ( "" )}
                {/* -----------recaptcha_V3 -------------- */}
                {this.state.recaptchaVersionSupported === "V3" ? (
                  <div className={classes.textCenter}>
                    <GoogleReCaptchaProvider reCaptchaKey={api.captchKeyV3}>
                      <GoogleReCaptcha
                          className="google-recaptcha-custom-class"
                          onVerify={this.btn_resend_act_get_recaptchaV3_token}
                          refreshReCaptcha={this.state.refreshReCaptchaV3}
                      />
                    </GoogleReCaptchaProvider>
                    <CustomButton
                      disabled={this.btn_resend_act_isDisabled()}
                      className={classes.transparentButton1}
                      color="default"
                      onClick={this.btn_resend_act}
                      type="submit">
                      {this.NSInforString("RegisterLight1OTP_btn_resend")}
                    </CustomButton>
                  </div>
                ) : ( "" )}
              </GridItem>
            </GridContainer>

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SPINNERS]----- */}
        {/* ------------------------- */}
        {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
          <GridContainer justify="center">
            <GridItem xs={3} sm={3} md={3}></GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
            </GridItem>
            <GridItem xs={3} sm={3} md={3}></GridItem>
          </GridContainer>
        )}
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------recaptcha_V3--------------------------------------
  //----------------------------------------------------------------------------------------------------
  //recaptcha_V3
  reset_recaptchaV3_token_TIMER = function() {
      var self = this;
      this.timer = setInterval(function() {
          self.reset_recaptchaV3_token("init");
      }, 90000)
  }
  //----------------------------------------------------------------------------------------------------
  reset_recaptchaV3_token(status) {
    let methName = filename+"reset_recaptchaV3_token ";
    //if(api.print_logs){console.log(methName);}

    if(this.state.recaptchaVersionSupported==="V3"){
      if(status==="init")   { this.setState({"refreshReCaptchaV3" : !this.state.refreshReCaptchaV3 }); this.generateRecaptchaV3(status); return; }
      if(status==="success"){ localStorage.setItem("recaptchaTokenV3", ""); /*this.setState({"refreshReCaptchaV3" : !this.state.refreshReCaptchaV3 }); this.generateRecaptchaV3();*/ return; }
      if(status==="failure"){ this.setState({"refreshReCaptchaV3" : !this.state.refreshReCaptchaV3 }); this.generateRecaptchaV3(status); return; }
      if(api.print_logs){console.log(methName+"this.state.refreshReCaptchaV3="+this.state.refreshReCaptchaV3);}
    }
  }
  //----------------------------------------------------------------------------------------------------
  generateRecaptchaV3(status) {
    let methName = filename+"generateRecaptchaV3 ";
    //if(api.print_logs){console.log(methName);}

    window.grecaptcha.execute(api.captchKeyV3, {action: "YOUR_ACTION_NAME"}).then(function(token) {
      if (token) {
        if(api.print_logs){console.log(methName+"status="+status+" token= "+token);}
        localStorage.setItem("recaptchaTokenV3", token);
      }
    });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_resend_act_isDisabled(){
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_resend_act_with_recaptcha(event) {
    let methName = filename+"btn_resend_act_with_recaptcha ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = (this.state.recaptchaVersionSupported==="V2") ? true : false; //true;//api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef_resend.reset();}this.reset_recaptchaV3_token("validation");
      return;
    }
    //++++++++
    //Continue
    //++++++++
    event.preventDefault();
    if(this.btn_resend_act_isDisabled()){ console.log(methName+"reset");  this.recaptchaRef_resend.reset();   }
    else                                { console.log(methName+"execute");this.recaptchaRef_resend.execute(); }
  }
  //----------------------------------------------------------------------------------------------------
  //recaptcha_V3
  btn_resend_act_get_recaptchaV3_token(token) {
    let methName = filename+"btn_resend_act_get_recaptchaV3_token ";
    //if(api.print_logs){console.log(methName);}

    if (token && token.length>300) {
      if(api.print_logs){console.log(methName+new Date()+" token=" +token);}
      localStorage.setItem("recaptchaTokenV3", token);
    }
  }
  //----------------------------------------------------------------------------------------------------
  btn_resend_act(event) {
    let methName = filename+"btn_resend_act ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = (this.state.recaptchaVersionSupported==="V2") ? true : false; //true;//api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef_resend.reset();}this.reset_recaptchaV3_token("validation");
      return;
    }
    //+++++++++++
    //[RECAPTCHA]
    //+++++++++++
    var recaptchaVerify = "";
    //recaptcha_V2
    if(this.state.recaptchaVersionSupported==="V2"){
      recaptchaVerify = shouldResetCaptcha ? JSON.stringify(this.recaptchaRef_resend.getResponse()) : "";
      if(api.print_logs){console.log(methName+"recaptchaVerify token= "+recaptchaVerify);}
    }
    //recaptcha_V3
    if(this.state.recaptchaVersionSupported==="V3"){
      recaptchaVerify = localStorage.getItem("recaptchaTokenV3");
      if(api.print_logs){console.log(methName+"recaptchaVerify token= "+recaptchaVerify);}
    }
    //++++++++
    //Continue
    //++++++++
    let parserObject_checkAppVersion_req = {};
    parserObject_checkAppVersion_req["platform"]   = api.platform;
    parserObject_checkAppVersion_req["appVersion"] = api.appVersion;

    var parserObject_omtRegistrationResendOTP_req = {};
    if(localStorage.getItem("prev_view").trim()==="LoginPage" || localStorage.getItem("prev_view").trim()==="TransferOnlineLogin"){
      try{ parserObject_omtRegistrationResendOTP_req = JSON.parse(localStorage.getItem("parserObject_omtRegistrationResendOTP_req"));}catch(err){console.log(methName+'err='+err);}
      let email_TMP     = parserObject_omtRegistrationResendOTP_req["email"];
      let telephone_TMP = parserObject_omtRegistrationResendOTP_req["telephone"];
      parserObject_omtRegistrationResendOTP_req["email"]           = email_TMP;
      parserObject_omtRegistrationResendOTP_req["telephone"]       = telephone_TMP;
      parserObject_omtRegistrationResendOTP_req["isMobile"]        = "1";
      parserObject_omtRegistrationResendOTP_req["recaptchaVerify"] = recaptchaVerify;
    }
    else{
      let parserObject_omtregistrationTriggerOTP_req = {};
      try{ parserObject_omtregistrationTriggerOTP_req = JSON.parse(localStorage.getItem("parserObject_omtregistrationTriggerOTP_req"));}catch(err){console.log(methName+'err='+err);}
      parserObject_omtRegistrationResendOTP_req["email"]           = parserObject_omtregistrationTriggerOTP_req["email"];
      parserObject_omtRegistrationResendOTP_req["telephone"]       = parserObject_omtregistrationTriggerOTP_req["telephone"];
      parserObject_omtRegistrationResendOTP_req["isMobile"]        = "1";
      parserObject_omtRegistrationResendOTP_req["recaptchaVerify"] = recaptchaVerify;
    }

    //event.preventDefault();
    this.startSpinners();
    setTimeout(function() { //Start the timer
      //---------------
      //checkAppVersion
      //---------------
      wu_AppVersion
      .wu_checkAppVersion(parserObject_checkAppVersion_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="RegisterLight1OTP"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        //if(shouldResetCaptcha){this.recaptchaRef_resend.reset();}this.reset_recaptchaV3_token("success");
        //this.stopSpinners();
        parserObject_omtRegistrationResendOTP_req["val1"] = res.val1;

        //---------------------------
        //wu_omtRegistrationResendOTP
        //---------------------------
        wu_RegisterLightService
        .wu_omtRegistrationResendOTP(parserObject_omtRegistrationResendOTP_req)
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="RegisterLight1OTP"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          if(shouldResetCaptcha){this.recaptchaRef_resend.reset();}this.reset_recaptchaV3_token("success");
          this.stopSpinners();
        })
        .catch(err => {
          if(shouldResetCaptcha){this.recaptchaRef_resend.reset();}this.reset_recaptchaV3_token("failure");
          this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
        });
      })
      .catch(err => { //wu_checkAppVersion
        if(shouldResetCaptcha){this.recaptchaRef_resend.reset();}this.reset_recaptchaV3_token("failure");
        this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText,"NET"); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_next_act_isDisabled(){
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_next_act_with_recaptcha(event) {
    let methName = filename+"btn_next_act_with_recaptcha ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = (this.state.recaptchaVersionSupported==="V2") ? true : false; //true;//api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.textField1.trim() === ""){ this.setState({"textField1_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef_send.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //------------------
    //validate 6digitpin
    //------------------
    let textField1text = this.state.textField1.trim();
    if(textField1text === ""){
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight1OTP_plh1")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef_send.reset();}
        return;
    }
    if(this.verifyGenericItem("8digitregisterpin",textField1text)===false){
        this.dialog_handleOpen(this.NSInforString("RegisterLight1OTP_8digitpinregister"));
        if(shouldResetCaptcha){this.recaptchaRef_send.reset();}
        return;
    }
    //++++++++
    //Continue
    //++++++++
    event.preventDefault();
    if(this.btn_next_act_isDisabled()){ console.log(methName+"reset");  this.recaptchaRef_send.reset();   }
    else                              { console.log(methName+"execute");this.recaptchaRef_send.execute(); }
  }
  //----------------------------------------------------------------------------------------------------
  //recaptcha_V3
  btn_next_act_get_recaptchaV3_token(token) {
    let methName = filename+"btn_next_act_get_recaptchaV3_token ";
    //if(api.print_logs){console.log(methName);}

    if (token && token.length>300) {
      if(api.print_logs){console.log(methName+new Date()+" token=" +token);}
      localStorage.setItem("recaptchaTokenV3", token);
    }
  }
  //----------------------------------------------------------------------------------------------------
  btn_next_act(event) {
    let methName = filename+"btn_next_act ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = (this.state.recaptchaVersionSupported==="V2") ? true : false; //true;//api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.textField1.trim() === ""){ this.setState({"textField1_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef_send.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //------------------
    //validate 6digitpin
    //------------------
    let textField1text = this.state.textField1.trim();
    if(textField1text === ""){
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight1OTP_plh1")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef_send.reset();}
        return;
    }
    if(this.verifyGenericItem("8digitregisterpin",textField1text)===false){
        this.dialog_handleOpen(this.NSInforString("RegisterLight1OTP_8digitpinregister"));
        if(shouldResetCaptcha){this.recaptchaRef_send.reset();}
        return;
    }
    var recaptchaVerify = shouldResetCaptcha ? JSON.stringify(this.recaptchaRef_send.getResponse()) : "";
    if(api.print_logs){console.log(methName+"recaptchaVerify="+recaptchaVerify);}
    //++++++++
    //Continue
    //++++++++
    var email_base64            = new Buffer(localStorage.getItem("HTTP_user").trim()).toString('base64');
    var verificationCode_base64 = new Buffer(textField1text.trim()).toString('base64');
    var parserObject_omtRegistrationValidateOTP_req = {};
    parserObject_omtRegistrationValidateOTP_req["email"]            = email_base64;
    parserObject_omtRegistrationValidateOTP_req["verificationCode"] = verificationCode_base64;
    parserObject_omtRegistrationValidateOTP_req["recaptchaVerify"]  = recaptchaVerify;

    //event.preventDefault();
    this.startSpinners();
    setTimeout(function() { //Start the timer
      //-----------------------------
      //wu_omtRegistrationValidateOTP
      //-----------------------------
      wu_RegisterLightService
      .wu_omtRegistrationValidateOTP(parserObject_omtRegistrationValidateOTP_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="RegisterLight1OTP"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        if(shouldResetCaptcha){this.recaptchaRef_send.reset();}
        //this.stopSpinners();

        this.stopSpinners();
        localStorage.setItem("parserObject_omtregistrationTriggerOTP_req", "");
        //+++++++++++++++++++
        //RegisterLight1Login
        //+++++++++++++++++++
        history.push(wu_Utilities.getNavigationURLs("RegisterLight1Login"));
      })
      .catch(err => {
        if(shouldResetCaptcha){this.recaptchaRef_send.reset();}
        this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+eventTMP);}

    if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
      this.setState({"textField0":eventTMP.trim(),});
    }
    else if(stateVar==="textField1"){
      this.setState({
        "textField1"          : eventTMP.trim(),
        "textField1_hasError" : (eventTMP.trim() === "") ? true : false,
      });
    }
    if(eventTMP.length>0 && wu_Utilities.offline_validate_numericCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.digits")); this.setState({"textField1_hasError":true}); return; }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="8digitregisterpin")                { return wu_Utilities.offline_validate_8digitregisterpin(val);  }

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg){
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Autocomplete--------------------------------------
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_autoCompleteDropDown(){
    return filename+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_Textfields(){
    //return filename+Math.random().toString().replace(/0\./g,"");
    //return filename.replace(/ /g,"")+Math.random().toString().replace(/0\./g,"");
    return Math.random().toString().replace(/0\./g,"")+"RG4"+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
}
RegisterLight1OTP.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(RegisterLight1OTPStyle)(RegisterLight1OTP)
);
